<template>
  <div>
    <b-card>
      <div class="organism-alert-management_header">
        <span class="header__label">Alert List</span>
        <atom-button
          v-if="hasUpdatePermission"
          buttonId="create-new-alert"
          class="header__button"
          @click="clickCreateNewAlert"
        >
          <template>Create New Alert</template>
        </atom-button>
      </div>

      <div class="organism-alert-management_content">
        <molecule-list-alert
          :alertData="alertData"
          :canUpdate="hasUpdatePermission"
          @onClickSwitchEnabled="onClickSwitchEnabled"
          @selectedCard="clickEditAlert"
        ></molecule-list-alert>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeListAlert from "@/components/molecules/serverManagementModule/alert/MoleculeListAlert.vue"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"
export default {
  name: "OrganismAlertManagement",
  components: {
    BCard,
    AtomButton,
    MoleculeListAlert,
  },
  props: {
    alertData: {
      type: Array,
      required: true,
    },
  },
  emits: ["toggleAlert"],
  mixins: [mixinsUser],
  data() {
    return {}
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SMS.ALERT_WRITE)
    },
  },
  methods: {
    clickCreateNewAlert() {
      this.$router.push("/server-management/alert/create")
    },
    clickEditAlert(alert) {
      this.$router.push("/server-management/alert/edit/" + alert.id)
    },
    onClickSwitchEnabled(id) {
      this.$emit("toggleAlert", id)
    },
  },
}
</script>

<style lang="scss" scoped>
// header
.organism-alert-management_header {
  display: flex;
  justify-content: space-between;
}
.header__label {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

// content
.organism-alert-management_content {
  margin-top: 40px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
